import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DealerSpecialTool, UpdatedDealerSpecialTool } from 'projects/Administration/src/app/business-entities/dealer-special-tool-view-model';
import { DealerSpecialToolBusinessService } from 'projects/Administration/src/app/business-services/dealer-special-tool.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-edit-dealer-special-tool',
  templateUrl: './edit-dealer-special-tool.component.html',
  styleUrls: ['./edit-dealer-special-tool.component.css']
})
export class EditDealerSpecialToolComponent implements OnInit, OnDestroy {
  currentlagSub: Subscription
  editSpecialTool = false;
  dealerSpecialTool: DealerSpecialTool
  id: number;
  editSpecialToolForm: FormGroup;
  image: string;
  language: string
  constructor(
    private formBuilder: FormBuilder,
    private dealerSpecialtoolService: DealerSpecialToolBusinessService,
    private spinner: NgxSpinnerService,
    private userService: UserDataService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cookieservice: CookieService,
    private activeModal : NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.dealerSpecialtoolService.isEdit = true;
    this.editSpecialToolForm = this.formBuilder.group({
      brandName: [],
      dealerName:[''],
      pc: [''],
      lcv: [''],
      truck: [''],
      partNumber: [''],
      partDescription: [{value: '', disabled: true}],
      partGroup: [''],
      isActive: [false],
      // partLocation: ['', [Validators.required, Validators.maxLength(9)]],
      takeoutPartQuantity: [''],
      totalPartQuantity: ['', [Validators.required]],
      usedBy: [''],
      vehicletype:['']
    });
    this.getData();
  }
  async getData() {
    if(this.currentlagSub){
      this.currentlagSub.unsubscribe();
    }
    this.route.params.subscribe(params => this.id = params['id']);
    this.id = this.dealerSpecialtoolService.DealerSpecialToolId;
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.language = x
      this.getDealerSpecialTool(this.id);
    });
  }
  get cpf() {
    return this.editSpecialToolForm.controls;
  }
  async getDealerSpecialTool(id: number) {
    this.spinner.show();
    let Language = this.cookieservice.get('userSelectedLanguage');
    await this.dealerSpecialtoolService.GetDealerSpecialToolById(id,Language).then(result => {
      if (result) {
        this.dealerSpecialTool = result;
        this.image = this.dealerSpecialTool.partImage;
        this.editSpecialToolForm.patchValue({
          ...result,
          vehicletype:this.dealerSpecialTool.vehicleType
        })
      }
    })
    this.spinner.hide();
  }

  editDealerSpecialTools() {
    this.spinner.show();
    if ((this.editSpecialToolForm.get('totalPartQuantity').value) > this.dealerSpecialTool.takeoutPartQuantity) {
      let currentUser = this.userService.currentUserValue.id;
      let viewModel: UpdatedDealerSpecialTool = {
        id: this.dealerSpecialTool.dealerSpecialToolId,
        // PartLocation: this.editSpecialToolForm.get('partLocation').value,
        TotalQuntity: this.editSpecialToolForm.get('totalPartQuantity').value,
        IsActive: this.editSpecialToolForm.get('isActive').value,
        UpdatedBy: currentUser
      }
      this.dealerSpecialtoolService.UpdateDealerSpecialTool(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          let successmsg = this.translate.instant("lblDealerSpecialToolUpdated");
          this.toastr.success(successmsg);
          this.spinner.hide();
          this.dealerSpecialtoolService.dealerID = this.dealerSpecialTool.dealerId;
          this.activeModal.close({ success: true });
        }
        else if (res.responseObject === false) {
          this.spinner.hide();
          let errormsg = this.translate.instant("lblDealerSpecialToolExist");
          this.toastr.warning(errormsg);
        }
      });
    }
    else {
      let errormsg = this.translate.instant("lblTotalQuntityValidation");
      this.toastr.error(errormsg);
    }
    this.spinner.hide();
  }
  ngOnDestroy(): void {
    this.currentlagSub.unsubscribe();
  }
 
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }
  
}
